module.exports = __webpack_public_path__ + "static/img/4.edaf476.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/4.jpg
// module id = QMnS
// module chunks = 1